import React from 'react'

import PostIt from '../../assets/images/postit.svg'
import Image from '../atoms/Image'
import Richtext from '../atoms/Richtext'

const Postit = ({ text, text_size }) => {
  return (
    <div className="postit">
      <Image image={PostIt} />
      <div className="postit-text-wrapper">
        <Richtext
          className={`postit-text ${
            text_size === 'xl' ? 'postit-text-xl' : ''
          }`}
          text={text}
        />
      </div>
    </div>
  )
}

export default Postit
